import _min from 'lodash/min'
import _max from 'lodash/max'
import moment from 'moment'

export const getMinMax = (trackDays, data, platform) => {
  const counts = data.filter(d => !!d[platform]).map(d => d[platform])
  const offset = 0.08
  const coinF = platform === 'bitcointalk' ? 0.2 : 1
  const intervalF = trackDays  / 14
  const mid = ((_max(counts) - _min(counts)) / 2) + _min(counts)
  const range = offset * intervalF * coinF
  const minMax = [
    mid * ( Math.max(1 - range, 0)),
    mid * ( 1 + range)
  ]
  return minMax
}

export const formatUnix = (unix) =>  {
  return moment.unix(unix).format('DD. MMM YYYY - HH:mm')
}

export const allPlatforms = [ 'reddit', 'reddit_a', 'reddit_m', 'telegram', 'telegram_a', 'bitcointalk', 'price', 'discord', 'discord_a' ] // 'medium'

export const colors = {
  'twitter':     '#1da1f2',
  'reddit':      'orangered',
  'reddit_a':    '#ff79c1',
  'reddit_m':    '#f56565', // '#ffb237',
  'reddit_ms':   '#05b8c3',
  'telegram':    '#4910ca',
  'telegram_a':  '#9256f1',
  'medium':      '#03a87c',
  // 'bitcointalk': '#7fa731',
  'bitcointalk': '#efd316',
  'discord':     '#32b91b',
  'discord_a':   '#9aff9a',
  'price':       'lightgrey',
}

// bitscreener DATA
// export const transformPriceData = (data, satF) =>
//   data.ts.map((ts, i) => ({ time: parseInt(ts, 10) / 1000, price: parseFloat(data.open[i]) * satF})).concat(
//     data.ts.map((ts, i) => ({ time: parseInt(ts, 10) / 1000, volume:  parseFloat(data.vlm[i])}))
//   )

export const transformPriceData = (data, untilTime, satF) => {
  const lastDataPoint = data[data.length - 1]
  return (
    data.map(d => ({ time: parseInt(d.time, 10), price: parseFloat(d.open) * satF})).concat(
                   { time: untilTime,            price: parseFloat(lastDataPoint.close * satF) }).concat( // adding the closePrice of the last bucket as a new data-point
    data.map(d => ({ time: parseInt(d.time, 10), volume:  parseFloat(d.volumeto)})))) // adding tradingVolumen
}

export const getDot = (trackDays, color, isMobile) => {
  if(isMobile) return { r: 1, fill: color }
  if(trackDays === 1)  return { r: 1, fill: color }
  if(trackDays === 7)  return { r: 1, fill: color }
  if(trackDays === 14) return { r: 1, fill: color }
  if(trackDays === 30)  return { r: 1, fill: color }
  return { r: null }
}

export const getBarSize = (trackDays, isMobile) => {
  if(isMobile) return 3
  if(trackDays === 1)  return 8
  if(trackDays === 7)  return 8
  if(trackDays === 14) return 5
  if(trackDays === 30)  return 2
}

export const transformMentions = (data, frequency, afterUnix, beforeUnix) => {

  const msToAdd = frequency * 60 * 60
  const _data = data
    .map(d => ({ ...d, doc_count: d.doc_count === 0 ? 0 : d.doc_count - 1 })) // doing minus one on the graph to minimize noise
    .map(d => ({ ...d, key: d.key + msToAdd })) // pushshipft shows the start of interval-bucket -> we want the end of the bucket
    .filter( d => d.key < beforeUnix ) // hiding the last bucket because it is always an unfinished bucket ( showing to few counts )
  // removing zero-counts between to spikes to smoothe the graph, without loosing spikes:
  for ( let i = _data.length - 1; i >= 0; i-- ) {
    if (
      _data[i] && _data[i - 1] && _data[i - 2] &&
      _data[i].doc_count > 0 &&
      _data[i - 1].doc_count === 0 &&
      _data[i - 2].doc_count > 0
    ) {
      _data[i - 1] = null
    } else if (
      _data[i] && _data[i - 1] && _data[i - 2] && _data[i - 3] &&
      _data[i].doc_count > 0 &&
      _data[i - 1].doc_count === 0 &&
      _data[i - 2].doc_count === 0 &&
      _data[i - 3].doc_count > 0
    ) {
      _data[i - 1] = null
      _data[i - 2] = null
    }
  }

  return _data.filter(Boolean)
}



// WEBPACK FOOTER //
// ./src/helpers/helpers.js